import { useTranslation } from 'react-i18next';
import { MessageCircle } from 'lucide-react';

const WhatsAppFloat = () => {
  const { i18n } = useTranslation();

  const messages: Record<string, string> = {
    sr: 'Zdravo! Zanima me termin u PHYSIOWRLD klinici.',
    en: 'Hello! I would like to book an appointment at PHYSIOWRLD clinic.',
    ru: 'Здравствуйте! Я хотел бы записаться на приём в клинику PHYSIOWRLD.',
  };

  const lang = (i18n.language || 'sr').split('-')[0];
  const msg = messages[lang] || messages.sr;
  const href = `https://wa.me/381605037477?text=${encodeURIComponent(msg)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-6 left-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-background"
      style={{ backgroundColor: '#25D366' }}
    >
      <MessageCircle className="w-7 h-7 text-white" />
    </a>
  );
};

export default WhatsAppFloat;
